export function loadImage() {
  // eslint-disable-next-line

  console.log('preload');
  // Object.keys(imagesObject).map((key, index) => {
  //   const img = new Image();
  //   img.src = imagesObject[key];
  // });
}
